import http from "./http"
const recheck = {
  //待查重稿件
  getDuplicateList(f_subjectId, f_title, type, order, sort, page, size) {
    return http.post("recheck/article/duplicateList?f_subjectId=" + f_subjectId + "&f_title=" + f_title + "&type=" + type + "&order=" + order + "&sort=" + sort + "&page=" + page + "&size=" + size, {})
  },

  //已查重稿件
  getAlreadyDuplicateList(f_subjectId, f_title, type1, type2, order, sort, page, size) {
    return http.post("recheck/article/alreadyDuplicateList?f_subjectId=" + f_subjectId + "&f_title=" + f_title + "&type1=" + type1 + "&type2=" + type2 + "&order=" + order + "&sort=" + sort + "&page=" + page + "&size=" + size, {})
  },

  //下载待查重的稿件附件
  downloadDuplicate(articleIds) {
    let modal = {
      articleIds: articleIds,
    }
    return http.post("recheck/article/downloadDuplicate", modal, { responseType: "blob" })
  },

  //下载待查重的稿件著作权授权书附件
  downloadLicense(articleIds) {
    let modal = {
      articleIds: articleIds,
    }
    return http.post("recheck/article/downloadCopyright", modal, { responseType: "blob" })
  },

  //登记重复率
  doDcrate(articleId, type, dcrate) {
    return http.post("editor/article/repeat_one?articleId=" + articleId + "&type=" + type + "&dcrate=" + dcrate, {})
  },

  //上传查重文件
  /* updateDcFile(articleId,attachCode,attachId){
    return http.post("recheck/upload/dcFile",{});
  }, */

  doDcFile(articleId, attachId, attachCode) {
    var modal = {
      articleId: articleId,
      attachId: attachId,
      attachCode: attachCode,
    }
    return http.post("recheck/upload/dcFile", modal)
  },
}
export default recheck
